<div class="flex-row header-wrapper">
  <h3>Disclaimer</h3>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="button-close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="main-text-font">
  <div class="content-wrapper">
    <p>This DPC Data Filings Summary report and the information contained herein (the "Report") is provided subject to
      the
      terms and conditions of the License Agreement between DPC Data Inc. ("DPC") and the company on whose behalf this
      Report is being accessed (the "Company"). Please refer to the License Agreement for usage restrictions,
      disclaimers
      and other important terms regarding this Report.
    </p>
    <p>DPC makes no representation or warranty with regard to the accuracy or completeness of the information contained
      within this Report. DPC relies on third party information in preparing this Report. Such third party information
      may
      contain errors or omissions. DPC shall have no liability for any errors or omissions with respect to this Report.
    </p>
    <p>
      This Report does not reflect any information that was not available to DPC as of the effective date of this
      Report.
      DPC has no obligation to update the Report with any such information.
    </p>
    <p>
      DPC provides this Report solely for informational purposes. In no event will this Report be construed as an
      opinion
      by DPC with respect to any compliance or non-compliance by any issuer or obligor that is the subject of this
      Report
      with its continuing disclosure obligations, or as to the materiality of any information contained in this Report.
      Company is solely responsible for making any determinations with respect to the foregoing matters.
    </p></div>
</mat-dialog-content>
